import { Layout } from 'antd';
import { Link } from 'react-router-dom';

const { Header: AntHeader } = Layout;

export default function Header() {
  return (
    <AntHeader
      style={{
        background: '#001529',
        padding: '0 24px',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        height: '64px',
        lineHeight: '64px',
      }}
    >
      <div
        className="container"
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Link
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            color: '#fff',
          }}
        >
          <img
            src="/images/logo-white.png"
            alt="AutoPlace Logo"
            height="32"
            style={{ marginRight: '12px' }}
          />
        </Link>
      </div>
    </AntHeader>
  );
}
